module.exports = "images/transport_train.d468b2ea9b631e99bf7c1a596749c114.png";